// Import brand images
import tigerLogo from '../pages/Brands/assets/0040184_tiger_345.png';
import zojirushiLogo from '../pages/Brands/assets/0040210_zojirushi_345.jpeg';
import cuchenLogo from '../pages/Brands/assets/0040190_cuchen_345.png';
import panasonicLogo from '../pages/Brands/assets/0010958_panasonic_345.png';
import saluxLogo from '../pages/Brands/assets/0010953_salux_345.png';
import joycookLogo from '../pages/Brands/assets/0040191_joycook_345.png';
import joyLifeLogo from '../pages/Brands/assets/0010969_joy-life_345.png';
import harioLogo from '../pages/Brands/assets/0040196_hario_345.png';
import benrinerLogo from '../pages/Brands/assets/0040197_benriner_345.jpeg';
import glasslockLogo from '../pages/Brands/assets/0040198_glasslock_345.jpeg';
import cleanwrapLogo from '../pages/Brands/assets/0040199_cleanwrap_345.jpeg';
import edisonChopsticksLogo from '../pages/Brands/assets/0040204_edison-chopsticks_345.jpeg';
import natureRepublicLogo from '../pages/Brands/assets/0040205_nature-republic_345.jpg';
import bigenLogo from '../pages/Brands/assets/0010963_bigen_345.png';
import salonpasLogo from '../pages/Brands/assets/0024921_salonpas_345.jpeg';
import viaLogo from '../pages/Brands/assets/0040209_via_345.jpeg';

export const brands = [
  { name: 'TIGER', logo: tigerLogo },
  { name: 'ZOJIRUSHI', logo: zojirushiLogo },
  { name: 'CUCHEN', logo: cuchenLogo },
  { name: 'PANASONIC', logo: panasonicLogo },
  { name: 'SALUX', logo: saluxLogo },
  { name: 'JOYCOOK', logo: joycookLogo },
  { name: 'JOY LIFE', logo: joyLifeLogo },
  { name: 'HARIO', logo: harioLogo },
  { name: 'BENRINER', logo: benrinerLogo },
  { name: 'GLASSLOCK', logo: glasslockLogo },
  { name: 'CLEANWRAP', logo: cleanwrapLogo },
  { name: 'EDISON CHOPSTICKS', logo: edisonChopsticksLogo },
  { name: 'NATURE REPUBLIC', logo: natureRepublicLogo },
  //{ name: 'BIGEN', logo: bigenLogo },
  { name: 'SALONPAS', logo: salonpasLogo },
  { name: 'VIA', logo: viaLogo },
];
